/*
 * @Author: your name
 * @Date: 2021-05-14 16:02:59
 * @LastEditTime: 2022-04-07 14:43:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/moduleDefine.js
 */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'
const routerComponents = {
  indexAnalyse: () => import('./analyse/index.vue'),
  analysisEvaluation: () => import('./analysisEvaluation/index.vue'),
  qualityImprovementEvaluation: () =>
    import('./qualityImprovementEvaluation/index.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/',
      component: BasicLayout,
      meta: {
        title: '质量改进',
        icon: 'chart'
      },
      children: [
        {
          path: 'SJJCZG/SJJCZGMain',
          component: dynamicWrapper(
            ['qc-rectification/analyse'],
            routerComponents.indexAnalyse
          ),
          meta: { title: '上级检查整改', noCache: true }
        },
        {
          path: 'ZLGJPJ/ZLGJPJMain',
          component: dynamicWrapper(
            ['qc-rectification/qualityImprovementEvaluation'],
            routerComponents.qualityImprovementEvaluation
          ),
          meta: { title: '质量改进评价', noCache: true }
        },
        {
          path: 'FXYPJ/FXYPJList',
          component: dynamicWrapper(
            ['qc-rectification/analysisEvaluation'],
            routerComponents.analysisEvaluation
          ),
          meta: { title: '分析与评价', noCache: true }
        }
      ]
    }
  ]
}
